import React from 'react';
import Row from '../../../../../components/tag/Row';
import Span from '../../../../../components/tag/Span';
import OTButton from '../../../../../components/tag/OTButton';
import { FormattedMessage } from 'react-intl';

let { id: module_id } = module;

const CannotRemoveCloseContactModalContent = ({ name, closeModal }) => {
  return (
    <Row>
      <h4 className={'ot-modal__title'}>
        <FormattedMessage id={`${module_id}.title`} values={{ name }} />
      </h4>
      <p>
        <FormattedMessage id={`${module_id}.content`} />
      </p>
      <Row style={{ textAlign: 'center' }}>
        <Span>
          <OTButton
            message={'OK'}
            color={'darkBlue'}
            onClick={() => {
              closeModal();
            }}
          />
        </Span>
      </Row>
    </Row>
  );
};

export default CannotRemoveCloseContactModalContent;
